export const useProductLinksStore = defineStore('productLinks', {
  actions: {
    /**
     * Product Component Link Actions
     */

    async createProductComponentLink(
      id: string | number,
      productComponentId: string | number,
    ): Promise<ProductComponent | undefined> {
      try {
        const {data} = await apiPostProductComponentLink(id, productComponentId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductComponentLinks(
      id: string | number,
      limit?: number,
      offset?: number,
    ): Promise<PaginatedProductComponent | undefined> {
      try {
        const {data} = await apiGetProductComponentLinks(id, limit, offset);
        return data as PaginatedProductComponent;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductComponentLinkById(
      id: string | number,
      productComponentId: string | number,
    ): Promise<ProductComponent | undefined> {
      try {
        const {data} = await apiGetProductComponentLink(id, productComponentId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductComponentLink(
      id: string | number,
      productComponentId: string | number,
    ): Promise<ProductComponent | undefined> {
      try {
        const {data} = await apiDeleteProductComponentLink(id, productComponentId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },

    /**
     * Feature Link Actions
     */

    async readFeatureLinks(
      id: string | number,
      limit?: number,
      offset?: number,
    ): Promise<FeatureLink[] | undefined> {
      try {
        const {data} = await apiGetFeatureLinks(id, limit, offset);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateFeatureLinks(
      id: string | number,
      features: FeatureLink[],
    ): Promise<FeatureLink[] | undefined> {
      try {
        const {data} = await apiPutFeatureLinks(id, {features: features});
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },

    /**
     * Labor Component Link Actions
     */

    async createLaborComponentLink(
      id: string | number,
      laborComponentId: string | number,
    ): Promise<LaborComponent | undefined> {
      try {
        const {data} = await apiPostLaborComponentLink(id, laborComponentId);
        return data as LaborComponent;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readLaborComponentLinks(
      id: string | number,
      limit?: number,
      offset?: number,
    ): Promise<PaginatedLaborComponent | undefined> {
      try {
        const {data} = await apiGetLaborComponentLinks(id, limit, offset);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readLaborComponentLinkById(
      id: string | number,
      laborComponentId: string | number,
    ): Promise<LaborComponent | undefined> {
      try {
        const {data} = await apiGetLaborComponentLink(id, laborComponentId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteLaborComponentLink(
      id: string | number,
      laborComponentId: string | number,
    ): Promise<LaborComponent | undefined> {
      try {
        const {data} = await apiDeleteLaborComponentLink(id, laborComponentId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },

    /**
     * Service Level Objective Link Actions
     */

    async createServiceLevelObjectiveLink(
      id: string | number,
      serviceLevelObjectiveId: string | number,
    ): Promise<ServiceLevelObjective | undefined> {
      try {
        const {data} = await apiPostServiceLevelObjectiveLink(id, serviceLevelObjectiveId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readServiceLevelObjectiveLinks(
      id: string | number,
      limit?: number,
      offset?: number,
    ): Promise<PaginatedServiceLevelObjective | undefined> {
      try {
        const {data} = await apiGetServiceLevelObjectiveLinks(id, limit, offset);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readServiceLevelObjectiveLinkById(
      id: string | number,
      serviceLevelObjectiveId: string | number,
    ): Promise<ServiceLevelObjective | undefined> {
      try {
        const {data} = await apiGetServiceLevelObjectiveLink(id, serviceLevelObjectiveId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteServiceLevelObjectiveLink(
      id: string | number,
      serviceLevelObjectiveId: string | number,
    ): Promise<ServiceLevelObjective | undefined> {
      try {
        const {data} = await apiDeleteServiceLevelObjectiveLink(id, serviceLevelObjectiveId);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
